// extracted by mini-css-extract-plugin
module.exports = {"root":"ActionsCell_root__8VqkM","button":"ActionsCell_button__25ueF","editButton":"ActionsCell_editButton__72CpQ","deleteButton":"ActionsCell_deleteButton__1wDqV"};